import React from "react";

const ExportAxisLabel = ({
  text,
  position = "left",
  offset = 10,
  color = "#238787",
  fontSize = 12,
  fontWeight = 600,
  className,
}) => {
  const isLeft = position === "left";

  return (
    <div
      className={className}
      style={{
        position: "absolute",
        [isLeft ? "left" : "right"]: `${offset}px`,
        top: "50%",
        transform: "translateY(-50%) rotate(-90deg)",
        transformOrigin: "center",
        fontSize,
        fontWeight,
        color,
        whiteSpace: "nowrap",
        pointerEvents: "none",
        userSelect: "none",
      }}
    >
      {text}
    </div>
  );
};

export default ExportAxisLabel;
